import { GFullImage } from '@garmin/components-global-web/dist/components/g-full-image.js';
import { GHeading } from '@garmin/components-global-web/dist/components/g-heading.js';
import { GCopy } from '@garmin/components-global-web/dist/components/g-copy.js';
import { GFlex } from '@garmin/components-global-web/dist/components/g-flex.js';
import { GButton } from '@garmin/components-global-web/dist/components/g-button.js';
import { GCard } from '@garmin/components-global-web/dist/components/g-card.js';

if (!customElements.get('g-full-image')) {
  customElements.define('g-full-image', GFullImage);
}
if (!customElements.get('g-heading')) {
  customElements.define('g-heading', GHeading);
}
if (!customElements.get('g-copy')) {
  customElements.define('g-copy', GCopy);
}
if (!customElements.get('g-flex')) {
  customElements.define('g-flex', GFlex);
}
if (!customElements.get('g-button')) {
  customElements.define('g-button', GButton);
}
if (!customElements.get('g-card')) {
  customElements.define('g-card', GCard);
}